import React from "react"
import TopBar from "./tobBar"
import Header from "./header"
import Footer from "./footer"

export default function LayoutFrontend({ children }) {

    return (
        <React.Fragment>
            <TopBar />
            <Header />
                {children}
            <Footer />
        </React.Fragment>
    )
}